import { Box, Chip, Stack, Typography } from '@rossum/ui/material';
import { NODE_WIDTH } from './computeLayout';

/** Renders a labelled row of chips (e.g. "Dependencies: [chip] [chip]"). */
export const NodeDetailSection = ({
  label,
  items,
  color = 'default',
}: {
  label: string;
  items: string[];
  color?: 'default' | 'warning' | 'error';
}) => {
  if (items.length === 0) return null;
  return (
    <Box sx={{ mt: 0.75 }}>
      <Typography
        variant="caption"
        sx={{
          color: 'text.secondary',
          fontWeight: 600,
          mb: 0.25,
          display: 'block',
        }}
      >
        {label}
      </Typography>
      <Stack
        direction="row"
        gap={0.5}
        sx={{
          flexWrap: 'wrap',
          maxWidth: NODE_WIDTH - 16,
        }}
      >
        {items.map(item => (
          <Chip
            key={item}
            label={item}
            size="small"
            color={color}
            sx={{ height: 20, fontSize: '1.1rem', flexShrink: 0 }}
          />
        ))}
      </Stack>
    </Box>
  );
};
